import axios from 'axios';

function formatDateISO(date) {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? '+' : '-';
  const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    diff +
    pad(tzOffset / 60) +
    ':' +
    pad(tzOffset % 60)
  );
}

function createQueryParams({
  env,
  bank,
  provider,
  started,
  finished,
  groupBy,
}) {
  const params = {
    aggregate_by: 'tx_count',
    date_trunc_field: 'started',
    date_trunc_period: 'day',
    group_by: groupBy,
    status: 'Charged',
  };

  if (env !== 'all') {
    params.env = env;
  }

  if (provider) {
    params.provider = provider;
  }

  if (bank) {
    params.bank = bank;
  }

  if (started instanceof Date) {
    params.started_from = formatDateISO(started);
  }

  if (!finished) {
    finished = new Date();
  }

  if (finished instanceof Date) {
    params.finished_to = formatDateISO(finished);
  }

  return new URLSearchParams(params).toString();
}

export async function getTransactionsAggregate({
  token,
  env,
  bank,
  provider,
  started,
  finished,
  groupBy,
}) {
  const query = createQueryParams({
    env,
    bank,
    provider,
    started,
    finished,
    groupBy,
  });
  const url = `/api/v1/transactions/aggregate?${query}`;

  const response = await axios.get(url, {
    headers: { Authorization: token },
  });

  return response.data.aggr;
}

export async function getProfiles(token, env) {
  const params = [];

  if (env !== 'all') {
    params.push(`env=${env}`);
  }

  const response = await axios.get(`/api/v1/profile?${params.join('&')}`, {
    headers: { Authorization: token },
  });

  return await response.data;
}

export async function getWallets(token, env) {
  const params = ['type=provider'];

  if (env !== 'all') {
    params.push(`env=${env}`);
  }

  const response = await axios.get(`/api/v1/wallet?${params.join('&')}`, {
    headers: { Authorization: token },
  });

  const wallets = (await response.data?.data) || [];

  return wallets.map(wallet => {
    return {
      id: wallet.id,
      name: wallet.name,
      provider: wallet.provider,
    };
  });
}
